import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast/toast.component';
import { getPageStatus } from './shared/data/page-status';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  variablesExpanded = true;
  componentsExpanded = true;
  getPageStatus = getPageStatus;

  toggleVariables(): void {
    this.variablesExpanded = !this.variablesExpanded;
  }

  toggleComponents(): void {
    this.componentsExpanded = !this.componentsExpanded;
  }
}
